<template>
    <div class="mt-4">
        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
        >
            <template v-if="items.length == 0 && filter == ''">
                <div class="tsoft-alert mb-2" v-if="!hideEmptyAlert">
                    <span>Нет добавленных документов</span>
                </div>
            </template>
            <template v-else>
                <template v-if="!noActions">
                    <div class="row active-panel-block justify-content-between align-items-center m-0">
                        <div class="d-flex align-items-center">
                            <div class="active-panel-block_icon">
                                <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
                            </div>
                            <div class="active-panel-block_checkbox">
                                <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="all">
                                <label class="form-check-label font-weight-bold text-uppercase text-secondary" for="exampleCheck1">
                                    {{items.length == selected.length ? 'Снять выделение' : 'Выделить все'}}
                                </label>
                            </div>
                            <div class="active-panel-block_action ml-4">
                                <template v-if="pathGenerate">
                                        <b-spinner small variant="secondary"></b-spinner>
                                        <span class="text-secondary font-weight-bold ml-2 text-uppercase">Ожидайте...</span>
                                </template>
                                <template v-else>
                                    <template v-if="pathDownload == ''">
                                        <span
                                        :class="`cursor-pointer ${selected.length == 0 ? 'notdownload' : 'download'}`"
                                        @click="downloadDocuments"
                                        ><b>Сформировать архив</b>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <a :href="pathDownload" target="_blank" class="text-uppercase text-orange font-weight-bold" @click="pathDownload = ''">Скачать архив</a>
                                    </template>
                                </template>
                                <span :class="`cursor-pointer ml-4 ${selected.length == 0 ? 'not-trash' : 'trash'}`" @click="deleteDocument(null, 'multi-delete')">
                                    <i class="far fa-trash-alt mr-1"></i> <b>Удалить</b>
                                </span>
                            </div>    
                        </div>
                        <div 
                            class="active-panel-block_action" 
                        >
                            <div>
                                <b-icon
                                    v-if="$mq != 'sm'"
                                    icon="search"
                                    scale="1.3"
                                    class="table-input-search_icon"
                                    variant="secondary"
                                ></b-icon>
                                <input class="form-control table-input-search" type="search" placeholder="Поиск" v-model="filter">
                            </div>    
                        </div>
                    </div>
                    <div class="mb-2 py-3 px-2 text-center font-italic" v-if="items.length == 0 && filter != ''">
                        <span>Документы не найдены. Попробуйте изменить условия поиска.</span>
                    </div>                    
                </template>
                <div class="row pl-3 pr-3 mt-3">
                    <div class="col-md-12" v-for="(item, index) in items" :key="index">
                        <div class="row list-block shadow align-items-center mb-3 list-block__download">

                            <input type="checkbox" :value="item.id" v-model="selected">

                            <div class="list-block_doc ml-3">
                                <a class="cursor-pointer d-block position-relative" @click.prevent="openFile(item)">
                                    <img :id="'doc-logo-'+index" :src="'/img/icon-document.svg'" style="width: 44px;">
                                    <div class="list-block_doc_extention">{{ fileExtension(item.path) }}</div>
                                </a>

                            </div>
                            <div class="list-block_text ml-3">
                                <ul class="mb-0">
                                    <li><span class="text-secondary">Наименование документа:</span><span class="font-weight-bold text-uppercase text-brown ml-2">{{item.name}}</span></li>
                                    <li><span class="text-secondary">Описание документа:</span><span class="ml-2">{{item.description ? item.description : '-'}} </span></li>
                                    <li><span class="text-secondary">Создан:</span><span class="text-brown ml-2">{{item.created_at}}</span><template v-if="item.creator"><span class="text-brown ml-1">|</span><span class="text-brown ml-1">{{item.creator.name}}</span></template></li>
                                </ul>
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="list-block_type ml-3">
                                    <span class="text-secondary font-weight-bold text-uppercase">{{item.type ? item.type.name : '-'}}</span>
                                </div>
                                <div class="list-block_action ml-3">
                                    <a :href="hfs + item.path" download class="list-block_icon cursor-pointer p-1">
                                        <i class="fas fa-download"></i>
                                    </a>
                                </div>
                                <div class="list-block_action ml-3">
                                    <span class="list-block_icon cursor-pointer p-1" @click="openFile(item)">
                                        <i class="far fa-eye"></i>
                                    </span>
                                </div>
                                <div class="list-block_action ml-3" v-if="!noActions">
                                    <span class="list-block_icon cursor-pointer p-1" @click="editDocument(index)">
                                        <i class="fas fa-pencil-alt"></i>
                                    </span>
                                </div>
                                <div class="list-block_action ml-3" v-if="!noActions">
                                    <span class="list-block_icon list-block_icon_remove cursor-pointer p-1" @click="deleteDocument(index, 'delete')">
                                        <i class="far fa-trash-alt"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-modal
                    ref="editDocument"
                    title="Редактирование документа"
                    hide-footer
                    centered
                >
                    <div>
                        <form @submit.prevent="updateDocument()">
                            <div class="form-group">
                                <label>Название документа</label>
                                <input type="text" class="form-control" v-model="editDocumentItem.name">
                            </div>
                            <div class="form-group">
                                <label>Описание документа</label>
                                <input type="text" class="form-control" v-model="editDocumentItem.description">
                            </div>
                            <div class="form-group">
                                <label>Дата составления документа (при необходимости)</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    v-model="editDocumentItem.date_of_document"
                                >
                            </div>
                            <div class="form-group">
                                <label for="reference_document_type_id">Тип документа</label>
                                <tsoft-select-of-properties
                                    :reference_id="34"
                                    :needNullElement="false"
                                    :needMultipleSelect="false"
                                    :defaultSelectName="`Выберите тип документа`"
                                    :internalSearch="true"
                                    :excludeArray="excludeAddDocumentTypeArray"
                                    :selected="editDocumentItem.reference_document_type_id"
                                    @set="(value) => {editDocumentItem.reference_document_type_id = value}"
                                ></tsoft-select-of-properties>
                            </div>
                            <button class="btn btn-primary float-right">Сохранить</button>
                        </form>
                    </div>
                </b-modal>
            </template>

            <div class="table-pagination-block mt-2">
                <div v-if="total > perPage || items.length > perPage">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="total"
                        :per-page="perPage"
                        :current-page="currentPage"
                        aria-controls="main-table"
                        size="md"
                        class="my-0"
                        pills
                    ></b-pagination>
                </div>
                <div 
                    v-if="items.length > pageOptions[0] || total > perPage || items.length > perPage"
                    class="align-items-center d-flex position-absolute table-pagination__perpage"
                >
                    <div class="font-size-12 text-secondary mr-1">
                        <span>Показывать по</span>
                    </div>
                    <div>
                        <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            class="table-select-perpage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import debounce from '@/services/helpers';
    import {HOST_FOR_STORAGE, API_DOCUMENTS, API_DOWNLOAD_DOCUMENTS, API_MULTI_DELETE_DOCUMENTS} from '@/constants';
    import {
        defaultDataItems,
    } from '@/mixins';

    const initialEditDocumentItem = () => ({
        id: '',
        path: '',
        name: '',
        description: '',
        finance_id: '',
        creator_user_id: '',
        order_id: '',
        order_service_id: '',
        company_id: '',
        reference_document_type_id: '',
        date_of_document: '',
        deleted_at: '',
        created_at: '',
        updated_at: '',
        unit: ''
    })

    export default {
    mixins: [
        defaultDataItems
    ],
        props: {
            updateListDocument: { type: Array, required: false },
            hideEmptyAlert: { type: Boolean, default: false },
            orderId: { type: Number | String, required: false, default: '' },           //order id for showing documents
            creatorUserId: { type: Number | String, required: false, default: '' },     //creator user id for showing documents
            orderServiceId: { type: Number | String, required: false, default: '' },    //order service id for showing documents
            companyId: { type: Number | String, required: false, default: '' },         //company id for showing documents
            financeId: { type: Number | String, required: false, default: '' },         //finance id for showing documents
            taskId: { type: Number | String, required: false, default: '' },            //task id for showing documents
            referenceDocumentTypeIds: { type: Array,
                required: false,
                default: function () {
                    return []
                }
            },                                                                           //array of document type id for searching
            requestDocuments: { type: Boolean, default: false, required: false },       //activation of the component work process
            updateDocumentList: { type: Number, default: 1, required: false },          //activation of the component work process
            excludeAddDocumentTypeArray: {  type: Array,
                required: false,
                default: function () {
                    return [329, 330, 331, 332, 333, 338]
                }
            },                                                                          //if you need to exclude document type for adding
            noActions: { type: Boolean, default: false, required: false },              //if we whant to block actions on document card
        },
        data() {
            return {
                pathGenerate: false,
                pathDownload: '',
                selected: [],
                items: [],
                editDocumentItem: '',
                editDocumentIndex: -1,
                dataOverlay: true,
                hfs: HOST_FOR_STORAGE,
                perPage: 5,
                currentPage: 1,
                total: 0,
                pageOptions: [5, 25, 50],
                lastPage: 1,
                filter: ''
            }
        },
        watch: {
            requestDocuments: function(val){
                if (val == true) {
                    this.showDocuments()
                }
            },
            updateDocumentList: {
                handler(newVal, oldVal) {
                    if (newVal != oldVal && this.requestDocuments) {
                        this.showDocuments()
                    }
                }
            },
            updateListDocument: function(val){
                for(let i = 0; i < val.length; i++){
                    this.items.push(val[i])
                    if (i + 1 === val.length) {
                        this.$emit('clearDocumentList')
                    }
                }
            },
            'items.length': function() {
                if (this.items.length > this.perPage || (this.items.length < this.perPage && this.currentPage !== this.lastPage)) {
                    this.showDocuments();
                }
                if (this.items.length === 0 && this.currentPage !== 1) {
                    this.currentPage -= 1;
                }
            },
            currentPage: function() {
                this.showDocuments();
            },
            perPage: function() {
                this.currentPage = 1;
                this.showDocuments();
            },
            filter: debounce(function (value) {
                console.log("SEARCHED", value);
                this.showDocuments();
            }, 500)            
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),

            isB2CAccount() {
                return this.currentUser.role.includes('b2c-head-manager') || 
                        this.currentUser.role.includes('b2c-manager');
            },

            all: {
                get() {
                    return this.selected.length === this.items.length;
                },
                set(val) {
                    this.selected = val ? this.items.map(n => n.id) : [];
                },
            },
        },
        mounted() {
            this.editDocumentItem = initialEditDocumentItem()

            if (this.requestDocuments) {
                this.showDocuments()
            }
        },
        methods: {
            ...mapActions('fileViewer', ['viewFile']),
            openFile(item) {
                if (this.fileExtension(item.path) !== 'txt') {
                    this.viewFile({name: item.name, src: this.hfs + item.path})
                } else {
                    window.open(this.hfs + item.path, '_blank');
                }
            },
            //download archive document
            downloadDocuments() {
                this.pathGenerate = true
                api.call('post', API_DOWNLOAD_DOCUMENTS, this.selected)
                .then(({data}) => {
                    this.pathDownload = data
                    this.pathGenerate = false
                    this.selected = []
                })
            },
            //list uploaded documents
            showDocuments() {
                this.dataOverlay = true;
                let additionalGetParameter = ''

                additionalGetParameter += (this.isB2CAccount ? `&unit=B2C`: ``);    
                additionalGetParameter += (this.orderId ? `&order_id=${this.orderId}`: ``);
                additionalGetParameter += (this.creatorUserId ? `&creator_user_id=${this.creatorUserId}`: ``);
                additionalGetParameter += (this.orderServiceId ? `&order_service_id=${this.orderServiceId}`: ``);
                additionalGetParameter += (this.companyId ? `&company_id=${this.companyId}`: ``);
                additionalGetParameter += (this.financeId ? `&finance_id=${this.financeId}`: ``);
                additionalGetParameter += (this.taskId ? `&task_id=${this.taskId}` : '');
                additionalGetParameter += (this.referenceDocumentTypeIds ? `&reference_document_type_ids=${this.referenceDocumentTypeIds}`: ``);
                additionalGetParameter += (this.filter ? `&q=${this.filter}` : '');

                api.call("get", `${API_DOCUMENTS}?${additionalGetParameter}&page=${this.currentPage}&per_page=${this.perPage}`)
                .then(({data}) => {
                    this.items = data.data;
                    this.total = data.total;
                    this.lastPage = data.last_page;
                })
                .finally(() => {
                    this.dataOverlay = false
                })
            },
            //edit document
            editDocument(index) {
                this.$refs['editDocument'].show() //open modal

                this.editDocumentIndex = index
                this.editDocumentItem = this.items[index]
            },
            //update document
            updateDocument() {
                let id = this.editDocumentItem.id
                this.$refs['editDocument'].hide() //close modal

                this.dataOverlay = true

                const updateDocumentFields = {
                    'name': this.editDocumentItem.name,
                    'description': this.editDocumentItem.description,
                    'reference_document_type_id': this.editDocumentItem.reference_document_type_id,
                    'date_of_document': this.editDocumentItem.date_of_document
                }

                api.call("put", `${API_DOCUMENTS}/${id}`, updateDocumentFields)
                .then(({data}) => {
                    this.items[this.editDocumentIndex] = Object.assign(this.items[this.editDocumentIndex], data)
                    this.$emit('onFileOperationCompleted', true)
                    this.makeToast('info', 'Изменения документа ' + data.name + ' сохранены')
                })
                .finally(() => {
                    this.dataOverlay = false
                    this.editDocumentItem = initialEditDocumentItem()
                    this.editDocumentIndex = -1
                })
            },
            //select type trash document
            deleteDocument(index, typeDelete) {
                this.$swal({
                    title: 'Подтвердите удаление!',
                    html: 'Вы можете отменить действие выбрав <b>нет</b>',
                    showCancelButton: true,
                    cancelButtonText: 'Нет',
                    confirmButtonText: 'Удалить',
                }).then((result) => {
                    if (!result.isConfirmed) {
                        return
                    }
                    this.dataOverlay = true
                    switch (typeDelete) {
                        case 'multi-delete':
                            this.apiMultiDeleteDocument(this.selected)
                            break;
                        case 'delete':
                            let id = this.items[index].id
                            this.apiSingleDeleteDocument(index, id)
                            break;
                    }
                })
            },
            //multi delete document
            apiMultiDeleteDocument(arrSeletedId){
                api.call('post', API_MULTI_DELETE_DOCUMENTS, arrSeletedId)
                .then(() => {
                    for(let indexDoc in arrSeletedId){
                        this.items.splice(this.items.findIndex(i => i.id == arrSeletedId[indexDoc]), 1)
                    }
                    this.makeToast('danger', 'Документы удалены')
                    this.$emit('onFileOperationCompleted', true)
                })
                .catch(() => {
                    this.makeToast('danger', 'Не удалось удалить документы')
                })
                .finally(() => {
                    this.dataOverlay = false
                    this.selected = []
                })
            },
            //single delete document
            apiSingleDeleteDocument(index, id) {
                api.call("delete", `${API_DOCUMENTS}/${id}`)
                .then(() => {
                    this.items.splice(index, 1)
                    this.makeToast('danger', 'Документ удален')
                    this.$emit('onFileOperationCompleted', true)
                })
                .catch(() => {
                    this.makeToast('danger', 'Не удалось удалить документ')
                })
                .finally(() => {
                    this.dataOverlay = false
                })
            }
        },
    }
</script>
